export const { DOCUMENT_FILE_SIZE } = process.env;
